.steps {
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 288px;
  margin-inline: auto;

  &::before {
    position: absolute;
    top: 15px;
    left: 54px;
    width: 180px;
    content: '';
    border-top: 1px solid var(--color-border-normal);
  }
}

@media screen and (width >= 769px) {
  .steps {
    width: 361px;

    &::before {
      width: 277px;
    }
  }
}

.stepItem {
  z-index: var(--z-index-low);
  display: flex;
  flex-direction: column;
  gap: 9px;
  align-items: center;
  width: 84px;
  font-size: var(--font-size-xs);
}
